export default __webpack_public_path__ + "static/media/bpt-ocean.46b58c08.png";